export const DESK_NOTES_PATH = '/desk/notes';
export const DESK_NOTES_CREATE_PATH = '/desk/notes/new';

export function isDeskNotesPath(pathname: string): boolean {
  return pathname === DESK_NOTES_PATH || pathname === DESK_NOTES_CREATE_PATH;
}

export function shouldOpenCreateNoteFromLocation(
  pathname: string,
  searchParams: URLSearchParams,
): boolean {
  if (pathname === DESK_NOTES_CREATE_PATH) {
    return true;
  }
  return pathname === DESK_NOTES_PATH && searchParams.get('create') === '1';
}
